import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Request from './Request';
export class Reporting extends Request {
  constructor({
    agency: _agency,
    url,
    keycloak,
    signal
  }) {
    super({
      url,
      signal,
      keycloak
    });

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    _defineProperty(this, "getReports", async agency => {
      const response = await this.get({
        api: `reporting/getReportList`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "runReport", async (reportShortName, agency, queryProps) => {
      const response = await this.post({
        api: `reporting/runReport/${reportShortName}`,
        data: JSON.stringify(queryProps),
        qs: {
          agency
        }
      });

      if (!(response instanceof Response) && response !== null && response !== void 0 && response.reportData) {
        response.reportData = JSON.parse(response.reportData);
        console.log('report', response.reportData);
      }

      return response;
    });

    this.url = new URL(url);
    this.keycloak = keycloak;

    if (_agency) {
      this.baseParams = {
        agency: _agency
      };
    }

    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set(newValue) {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

}
export default Reporting;